<mat-paginator
  [length]="count"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="pageUpdate.emit($event)"
  showFirstLastButtons
  [class.disabled]="!count || pageSize === count"
>
</mat-paginator>
